// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    GIFT_GUIDE_PAGE_LOADING() {
      return {
        isLoading: true,
        giftGuidePage: action.giftGuidePage
      };
    },
    GIFT_GUIDE_PAGE_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        'gift-guide',
        'categoryPage'
      );

      adModelData.model.adzone = 'gift-guide/gift-guide';
      return {
        isLoading: false,
        data: action.homepage,
        ads: adModelData
      };
    },
    GIFT_GUIDE_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.giftGuidePage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
